var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OneCol',[_c('Heading',{attrs:{"title":_vm.$t('breaches.heading').toString(),"text":_vm.$t('breaches.text').toString(),"loading":_vm.loading}}),_c('BreachTable',{staticClass:"card",attrs:{"rows":_vm.rows,"meta":_vm.meta,"loading":_vm.loading,"error":_vm.error},on:{"refresh":_vm.refreshData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }